var React = require('react');

function InformationIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"textIndent":"0","textAlign":"start","lineHeight":"normal","textTransform":"none","blockProgression":"tb","-inkscapeFontSpecification":"Bitstream Vera Sans"},"d":"M16 4c-2.197 0-4 1.803-4 4s1.803 4 4 4 4-1.803 4-4-1.803-4-4-4zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm-5 7v5h2v5h-2v5h10v-5h-2V13h-8zm2 2h4v10h2v1h-6v-1h2v-9h-2v-1z","overflow":"visible","fontFamily":"Bitstream Vera Sans"}));
}

InformationIcon.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = InformationIcon;

InformationIcon.default = InformationIcon;
